import * as actions from './newrelicActions'

export const useMonitoring = () => {
  return actions
}
